// extracted by mini-css-extract-plugin
module.exports = {"publishButton":"PublishVideoButton_publishButton__1hUXX","publishIcon":"PublishVideoButton_publishIcon__17nYF"};